<template>
  <div id="extraData">
    <div class="public-content">
      <el-form :inline="true">
        <el-form-item label="表外数据：">
          <template>
            <accounting-period @defaultTime="defaultTime" :isDaterange="false"></accounting-period>
          </template>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" class="minButton" @click="getTableDataList">搜索</el-button>
        </el-form-item>
        <div class="fr">
          <el-button class="minButton" size="mini" @click="handleBatchSave">批量保存</el-button>
        </div>
      </el-form>
      <!-- 表格数据 -->
      <public-table :table="tableData">
        <template
          v-for="cell in tableData.config"
          v-show="cell.show == 'template'"
          slot-scope="props"
          :slot="cell.value"
        >
          <template v-if="cell.value === 'name'">
            <a
              :key="cell.value"
              href="javascript:;"
              v-text="props.scope.row.name"
              @click="handlerClick(props.scope.row)"
            ></a>
          </template>

          <template v-else-if="cell.value !== 'name'">
            <el-input
              :key="cell.value"
              size="small"
              v-model.number="props.scope.row[cell.value]"
              @focus="handleEditField($event, props.scope.row, cell.value)"
              @blur="handleCancelEdit($event, props.scope.row, cell.value)"
              v-if="props.scope.row.formula == 2"
            ></el-input>
            <span :key="cell.value" v-text="props.scope.row[cell.value]" v-else></span>
          </template>
        </template>
      </public-table>
    </div>
    <balance-sheet-dialog
      :dialogVisible.sync="isShowReport"
      :data="reportDialogData"
      @onRefresh="onRefresh"
      :showRegulation="true"
    ></balance-sheet-dialog>
  </div>
</template>
<script>
import accountingPeriod from "@/components/dialog/accountingPeriod";
import publicTable from "@/components/publicTable";
import balanceSheetDialog from "@/components/dialog/balanceSheetDialog";
export default {
  components: {
    publicTable,
    accountingPeriod,
    balanceSheetDialog
  },
  data() {
    return {
      form: {
        yearPeriods: ""
      },
      list: [], // 修改后的数据
      superPrevent: true, // 防止不做修改提交
      newcountYearNumber: "", // 当前本年累计金额
      nowperiodsNumber: "", // 当前本月金额
      isShowReport: false, // 显示弹框
      reportDialogData: {
        reportId: "",
        yearPeriods: "",
        style: ""
      },
      getOnce: true, // 执行一次
      tableData: {
        border: true, // 是否带有纵向边框
        stripe: true, // 是否带有斑马纹
        loading: false, // 是否显示加载动画
        hasSelect: false, // 是否显示多选
        hasOperation: false, // 是否有操作功能
        hasContextmenu: false, // 是否有右键功能
        hasShowSummary: false, // 是否显示合计行
        hasShowPagination: false, // 是否显示分页
        config: [
          {
            label: "项目",
            value: "name",
            show: "template"
          },
          {
            label: "行次",
            value: "sort",
            width: 80,
            show: "normal"
          },
          {
            label: "本年累计金额",
            value: "countYearNumber",
            show: "template"
          },
          {
            label: "本期金额",
            value: "periodsNumber",
            show: "template"
          }
        ],
        operation: {
          label: "操作",
          width: 200,
          value: "operation",
          data: []
        },
        data: [],
        page: {
          pageNo: 1,
          pageSize: 20,
          count: 10
        },
        center: {
          textAlign: "center"
        }
      }
    };
  },
  methods: {
    // 接收会计期间数据
    defaultTime(data) {
      this.form = Object.assign(this.form, {
        yearPeriods: this.$util.formatDate.format(
          data.yearPeriodsStart,
          "yyyyMM"
        )
      });
      if (this.getOnce) {
        this.getOnce = false;
        this.getTableDataList();
      }
    },
    // 批量保存
    handleBatchSave() {
      if (!this.list.length) {
        return this.$message.warning("您还没有做任何修改哟！");
      }
      const params = {
        list: this.list,
        yearPeriods: this.form.yearPeriods,
        type: 1
      };
      try {
        this.$http
          .post("reportFormSonByMon/saveReportSonMon", params)
          .then(res => {
            if (res && res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.superPrevent = true;
              this.list = [];
              this.getTableDataList();
            }
          });
      } catch (e) {}
    },
    // 显示弹窗
    handlerClick(row) {
      this.reportDialogData = Object.assign({}, this.reportDialogData, {
        reportId: row.id,
        yearPeriods: this.form.yearPeriods,
        style: row.style
      });
      this.isShowReport = true;
    },
    // 重载
    onRefresh(data) {
      data && this.getTableDataList();
    },
    // 获取表格数据
    getTableDataList() {
      try {
        this.tableData.loading = true;
        this.$http
          .post("reportform/offBalanceSheetData", this.form)
          .then(res => {
            this.tableData.loading = false;
            if (res && res.data.code == 1) {
              this.tableData.data = res.data.data;
            }
          });
      } catch (e) {
        this.tableData.loading = false;
      }
    },
    // 失去焦点
    handleCancelEdit(e, row, name) {
      if (
        this.newcountYearNumber === row.countYearNumber &&
        this.nowperiodsNumber === row.periodsNumber
      ) {
        this.superPrevent = true;
        return;
      }
      this.superPrevent = false;
      let params = {
        countYearNumber: row.countYearNumber,
        reportFormId: row.id,
        periodsNumber: row.periodsNumber
      };
      // 这里最外层if判断list的长度，即当前是否有修改的数据
      if (this.list.length) {
        // 再判断list中是否存在当前修改行的数据，有就直接替换
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].reportFormId == params.reportFormId) {
            this.list[i] = params;
            return;
          }
        }
      }
      // 当上面的判断都不满足就直接push
      this.list.push(params);
    },
    // 获取焦点
    handleEditField(e, row, name) {
      const input = e.target;
      input.select();
      this.newcountYearNumber = row.countYearNumber;
      this.nowperiodsNumber = row.periodsNumber;
    }
  }
};
</script>
<style lang='less' scoped>
</style>


// WEBPACK FOOTER //
// src/pages/reportForm/extraData.vue